<template>
  <div class="home">
    <span>欢迎使用</span>
    <button type="submit" @click="logout">退出</button>
  </div>
</template>

<script>
export default {
  name: 'HomeView',
  methods: {
    logout() {
      // 在用户点击退出后执行页面跳转
      this.$parent.showNav = false;
      this.$router.push('/');
    }
  }
}
</script>
